import { useEffect, useState } from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import './App.scss';
import SignIn from './containers/signIn/signIn';
import "@fontsource/inter";
import Main from './containers/main/main';
import AuthContext, { Roles, UserConfig } from './contexts/authContext';
import { FiltersTable, SortConfig, SortType, TableContext } from './contexts/tableContext';
import { Row } from '@tanstack/react-table';
import PermissionsContext, { FunctionTypes, ExtendedUserPermissions } from './contexts/permissionsContext';
import { defaultExtendedPermissions, defaultFunctionPermissions } from './helpers/rolesToPermissions';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { setupDatabase } from './database/indexedDbReadWrite';
import { notifyError } from './components/snackbar/snackbar';
// import { apiContext } from './contexts/apiContext';
// import { Logout } from './services/signInService/signInService';

function App() {
  const [authenticated, setAuthenticated] = useState(sessionStorage.getItem("SOPOtoken") ? true : false);
  const [user, setUser] = useState('');
  const [username, setUsername] = useState(sessionStorage.getItem("isActiveLoginSOPO") ?? '');
  const [userId, setUserId] = useState('');
  const [userRoles, setUserRoles] = useState<string[]>([]);
  const [userConfig, setUserConfig] = useState<UserConfig>({} as UserConfig);
  const [onlineMode, setOnlineMode] = useState(sessionStorage.getItem("SOPOonline") === 'true');
  const [notificationCount, setNotificationCount] = useState(0);
  const FunctionsPremissions: FunctionTypes = defaultFunctionPermissions();
  const [functionsPermissions, setFunctionsPermissions] = useState(FunctionsPremissions);
  const ExtendedUserPermissions: ExtendedUserPermissions = defaultExtendedPermissions();
  const [extendedUserPermissions, setExtendedUserPermissions] = useState(ExtendedUserPermissions);
  const rows: Row<any>[] = [];
  const [checkboxesTable, setCheckboxesTable] = useState(rows);
  const filters: FiltersTable[] = [{filterColumnName: "", filterColumnValue: ""}];
  const [filtersTableDb, setFiltersTableDb] = useState(filters);
  const [filtersTableTaskList, setFiltersTableTaskList] = useState(filters);
  const roles = Roles;
  const [reloadTable, setReloadTable] = useState(false);
  const sort: SortConfig = {sortType: SortType.None, filterColumnName: ""};
  const [sortConfigDb, setSortConfigDb] = useState(sort);
  const [sortConfigTaskList, setSortConfigTaskList] = useState(sort);

  useEffect(() => {
    setupDatabase().then((db) => {
      console.log('Database setup complete:', db);
    }).catch((error) => {
      notifyError({message: "Błąd podczas aktualizowania schematu bazy"})
      console.error('Failed to setup database:', error);
    });
  }, []);

  return (
    <AuthContext.Provider value={{ authenticated, setAuthenticated, user, setUser, userId, setUserId, username, setUsername, userConfig, setUserConfig, roles, userRoles, setUserRoles, onlineMode, setOnlineMode, notificationCount, setNotificationCount }}>
      <PermissionsContext.Provider value={{ functionsPermissions, setFunctionsPermissions, extendedUserPermissions, setExtendedUserPermissions }}>
        <DndProvider backend={HTML5Backend}>
          <TableContext.Provider value={{ checkboxesTable, setCheckboxesTable, filtersTableDb, setFiltersTableDb, filtersTableTaskList, setFiltersTableTaskList, reloadTable, setReloadTable, sortConfigDb, setSortConfigDb, sortConfigTaskList, setSortConfigTaskList }} >
            <Router>
              <div className="App">
                <Routes>
                  <Route
                    path="/"
                    element={
                      (!authenticated) ? <SignIn /> : <Navigate to="/main" />
                    }
                  />
                  <Route
                    path="/signin"
                    element={(!authenticated) ? <SignIn /> : <Navigate to="/main" />}
                  />
                  <Route
                    path="/main"
                    element={(authenticated) ? <Main /> : <Navigate to="/signin" />}
                  />
                </Routes>
              </div>
            </Router>
          </TableContext.Provider>
        </DndProvider>
      </PermissionsContext.Provider>
    </AuthContext.Provider>
  );
}

export default App;
